<template>
  <div v-bind="$attrs" class="overflow-hidden text-sm">
    <template v-if="!expanded && shouldShowReadMoreButton">
      <span v-html="truncatedContent" />
      ...
      <button
        type="button"
        class="inline rounded hover:text-primary text-sm underline"
        @click="toggleReadMore"
      >
        {{ $t('general.kftReadMore.readMoreLabel') }}
      </button>
    </template>
    <template v-else>
      <span v-html="content" />
      <button
        v-if="shouldShowReadMoreButton"
        type="button"
        class="inline rounded hover:text-primary text-sm underline"
        @click="toggleReadMore"
      >
        {{ $t('general.kftReadMore.readLessLabel') }}
      </button>
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  content: String,
  maxChars: {
    type: Number,
    default: 115,
  },
  preventExpand: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['toggle'])

const expanded = ref(false)

const shouldShowReadMoreButton = computed(
  () => props.content?.length > props.maxChars
)

const truncatedContent = computed(() => props.content?.slice(0, props.maxChars))

const toggleReadMore = () => {
  if (!props.preventExpand) {
    expanded.value = !expanded.value
  }
  emit('toggle', expanded.value)
}
</script>

<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
